import React from 'react';
import './Services.css';
import { IoShieldCheckmarkSharp } from "react-icons/io5";


const Services = () => {



  return (
    <section id='services'>
      <h5>What I Offer</h5>
      <h2>Services</h2>

      {/* Services Section */}
      <div className="container services__container">

        {/* Programmer Service */}
        <article className="service">
          <div className="service__head">
            <h3>Programmer</h3>
          </div>
          <ul className='service__list'>
            <li>
              <IoShieldCheckmarkSharp className='service__list-icon' />
              <p>Proficient in solving complex problems using <b>JavaScript, C++, and C#</b>, with a focus on algorithms, data structures, and system design.</p>
            </li>
            <li>
              <IoShieldCheckmarkSharp className='service__list-icon' />
              <p>Experienced in competitive programming, actively solving challenges on platforms like <a href="https://leetcode.com/u/syedmuhammadmaaz/" target='_blank' rel="noreferrer">LeetCode</a> to sharpen my problem-solving skills.</p>
            </li>
            <li>
              <IoShieldCheckmarkSharp className='service__list-icon' />
              <p>Developing efficient algorithms for real-world problems, optimized for performance and scalability.</p>
            </li>
            <li>
              <IoShieldCheckmarkSharp className='service__list-icon' />
              <p>Check out my <a href="https://github.com/syedmaazsaeed" target='_blank' rel="noreferrer">GitHub</a> for hands-on projects involving algorithm development, API integration, and innovative solutions.</p>
            </li>
          </ul>
        </article>

        {/* Web Development Service */}
        <article className="service">
          <div className="service__head">
            <h3>Web Development</h3>
          </div>
          <ul className='service__list'>
            <li>
              <IoShieldCheckmarkSharp className='service__list-icon' />
              <p>Specialist in full-stack web development using the <b>MERN Stack (MongoDB, Express, React, Node.js)</b>, building scalable, high-performance applications.</p>
            </li>
            <li>
              <IoShieldCheckmarkSharp className='service__list-icon' />
              <p>Proficient in <b>React.js</b>, creating dynamic, responsive front-end interfaces, optimized for speed and user experience.</p>
            </li>
            <li>
              <IoShieldCheckmarkSharp className='service__list-icon' />
              <p>Building interactive, mobile-first web apps with React.js is where I shine. I focus on delivering polished, responsive experiences that users love.</p>
            </li>
            <li>
              <IoShieldCheckmarkSharp className='service__list-icon' />
              <p>Familiar with <b>responsive design</b> principles, focusing on mobile-first development and cross-browser compatibility for optimal user experiences.</p>
            </li>
            
          </ul>
        </article>

        {/* Software Development Service */}
        <article className="service">
          <div className="service__head">
            <h3>Software Development</h3>
          </div>
          <ul className='service__list'>
            <li>
              <IoShieldCheckmarkSharp className='service__list-icon' />
              <p>Experienced in full-stack software development, from design to deployment, ensuring adherence to <b>Agile</b> methodologies and <b>DevOps</b> best practices.</p>
            </li>
            <li>
              <IoShieldCheckmarkSharp className='service__list-icon' />
              <p>Proficient in debugging, testing, and maintaining high-quality code with a focus on performance optimization and scalability.</p>
            </li>
            <li>
              <IoShieldCheckmarkSharp className='service__list-icon' />
              <p>Collaborated on open-source projects, contributing to a vibrant developer community. Check out my work on <a href="https://github.com/syedmaazsaeed" target='_blank' rel="noreferrer">GitHub</a>.</p>
            </li>
            <li>
              <IoShieldCheckmarkSharp className='service__list-icon' />
              <p>Hands-on experience across diverse domains from web systems and mobile apps to enterprise software projects.</p>
            </li>
            <li>
              <IoShieldCheckmarkSharp className='service__list-icon' />
              <p>Deep understanding of Software Project Management and Software Re-Engineering, proven through the successful delivery of capstone projects (Project I & II) with distinction</p>
            </li>
          </ul>
        </article>

        {/* AI and Machine Learning Service */}
        <article className="service">
          <div className="service__head">
            <h3>AI & Machine Learning</h3>
          </div>
          <ul className='service__list'>
            <li>
              <IoShieldCheckmarkSharp className='service__list-icon' />
              <p>Expert in <b>OpenAI API integration</b> for building conversational AI systems, chatbots, and intelligent applications.</p>
            </li>
            <li>
              <IoShieldCheckmarkSharp className='service__list-icon' />
              <p>Skilled in <b>ElevenLabs voice synthesis</b> and creating lifelike voice agents for real-time interactions.</p>
            </li>
            <li>
              <IoShieldCheckmarkSharp className='service__list-icon' />
              <p>Building <b>RAG (Retrieval-Augmented Generation)</b> systems and knowledge retrieval solutions using LangChain.</p>
            </li>
            <li>
              <IoShieldCheckmarkSharp className='service__list-icon' />
              <p>Developing custom AI tools and agents that integrate seamlessly with web applications and business workflows.</p>
            </li>
          </ul>
        </article>

        {/* Automation & Workflow Engineering */}
        <article className="service">
          <div className="service__head">
            <h3>Automation & Workflow Engineering</h3>
          </div>
          <ul className='service__list'>
            <li><IoShieldCheckmarkSharp className='service__list-icon' />
              <p>Expert in building automation pipelines with <b>n8n</b>, <b>Make</b>, and <b>Postman</b>.</p>
            </li>
            <li><IoShieldCheckmarkSharp className='service__list-icon' />
              <p>Automating repetitive tasks, data flows, and third-party integrations.</p>
            </li>
            <li><IoShieldCheckmarkSharp className='service__list-icon' />
              <p>Designing custom automation workflows that save time and reduce human error.</p>
            </li>
            <li><IoShieldCheckmarkSharp className='service__list-icon' />
              <p>Creating AI-powered automations where bots do not just move data but also make smart decisions.</p>
            </li>
            <li><IoShieldCheckmarkSharp className='service__list-icon' />
              <p>Helping businesses save time, cost, and effort by removing repetitive manual work with scalable automations</p>
            </li>
          </ul>
        </article>

        {/* Conversational AI & Voice Agents */}
        <article className="service">
          <div className="service__head">
            <h3>Conversational AI & Voice Agents</h3>
          </div>
          <ul className='service__list'>
            <li><IoShieldCheckmarkSharp className='service__list-icon' />
              <p>Designing <b>conversational AI systems</b> with OpenAI and ElevenLabs.</p>
            </li>
            <li><IoShieldCheckmarkSharp className='service__list-icon' />
              <p>Developing lifelike voice and text agents for real-time interactions.</p>
            </li>
            <li><IoShieldCheckmarkSharp className='service__list-icon' />
              <p>Custom AI tools tailored for business automation and customer engagement.</p>
            </li>
            <li><IoShieldCheckmarkSharp className='service__list-icon' />
              <p>Creating business-ready assistants for lead generation, customer support, and onboarding.</p>
            </li>
            <li><IoShieldCheckmarkSharp className='service__list-icon' />
              <p>Delivering project-proven solutions like Norbu Legal Marketing Agent (Inbound,Outbound, SMS), AI Receptionist,& CycleWise AI Health App for womens health tracking</p>
            </li>
          </ul>
        </article>

        {/* Open Source & Community */}
        <article className="service">
          <div className="service__head">
            <h3>Open Source & Community</h3>
          </div>
          <ul className='service__list'>
            <li><IoShieldCheckmarkSharp className='service__list-icon' />
              <p>Active <b>open-source contributor</b>, building tools and libraries.</p>
            </li>
            <li><IoShieldCheckmarkSharp className='service__list-icon' />
              <p>Sharing knowledge and projects on <a href="https://github.com/syedmaazsaeed" target='_blank' rel="noreferrer">GitHub</a>.</p>
            </li>
            <li><IoShieldCheckmarkSharp className='service__list-icon' />
              <p>Mentoring peers and engaging with developer communities worldwide.</p>
            </li>
          </ul>
        </article>

      </div>
    </section>
  );
}

export default Services;
